import { graphql } from '@/gql';
import type { ApplyManualSubsidyMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const applyManualSubsidy = async ({ requestId, subsidyAmt, notes }: ApplyManualSubsidyMutationVariables): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation ApplyManualSubsidy($requestId: String!, $subsidyAmt: Float!, $notes: String!) {
        applyManualSubsidy(requestId: $requestId, subsidyAmt: $subsidyAmt, notes: $notes) {
          partnerId
        }
      }
    `),
    variables: {
      requestId,
      subsidyAmt,
      notes,
    },
  });

  return !!response.data?.applyManualSubsidy;
};
